import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import useAnalytics from "@/lib/useAnalytics";
import MarketingPage from "@/pages/MarketingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function AnalyticsTracker() {
  useAnalytics();
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AnalyticsTracker />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0C1424",
              border: "1px solid #1A253D",
              color: "#F8FAFC",
              fontFamily: '"IBM Plex Sans", sans-serif',
              borderRadius: 0,
            },
          }}
        />
        <Routes>
          <Route path="/" element={<MarketingPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
